import { render, staticRenderFns } from "./CInputGroupText.vue?vue&type=template&id=395e5a9e&scoped=true&"
import script from "./CInputGroupText.vue?vue&type=script&lang=ts&"
export * from "./CInputGroupText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395e5a9e",
  null
  
)

export default component.exports